import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../assets/down.png'
import _imports_1 from '../../assets/performance/top_banner.png'
import _imports_2 from '../../assets/performance/footer.png'

const _withId = /*#__PURE__*/_withScopeId("data-v-b0d01212")

_pushScopeId("data-v-b0d01212")
const _hoisted_1 = {
  class: "Ecard",
  id: "trendChart"
}
const _hoisted_2 = { class: "testMain" }
const _hoisted_3 = { class: "fitter_title" }
const _hoisted_4 = /*#__PURE__*/_createVNode("span", null, " 删除 ", -1)
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" 编辑 ")
const _hoisted_6 = { class: "dialog-footer" }
const _hoisted_7 = /*#__PURE__*/_createTextVNode("取消")
const _hoisted_8 = /*#__PURE__*/_createTextVNode("确认")
const _hoisted_9 = /*#__PURE__*/_createTextVNode("发送报告")
const _hoisted_10 = /*#__PURE__*/_createVNode("span", null, [
  /*#__PURE__*/_createVNode("img", {
    src: _imports_0,
    alt: ""
  })
], -1)
const _hoisted_11 = /*#__PURE__*/_createVNode("span", null, "手动生成报告", -1)
const _hoisted_12 = { style: {"display":"flex","justify-content":"space-between","margin-top":"10px"} }
const _hoisted_13 = /*#__PURE__*/_createVNode("div", null, null, -1)
const _hoisted_14 = /*#__PURE__*/_createVNode("span", null, "清除缓存", -1)
const _hoisted_15 = {
  key: 0,
  class: "editRecipient"
}
const _hoisted_16 = /*#__PURE__*/_createTextVNode(" 可按如下任一形式批量添加： ")
const _hoisted_17 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_18 = /*#__PURE__*/_createTextVNode("1、zhangsan;lisi;wangwu ")
const _hoisted_19 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_20 = /*#__PURE__*/_createTextVNode("2、zhangsan(张三);lisi(李四);wangwu(王五) ")
const _hoisted_21 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_22 = /*#__PURE__*/_createTextVNode("3、zhangsan(张三) <zhangsan@tencent.com>;lisi(李四) <lisi@tencent.com>; wangwu(王五) <wangwu@tencent.com> ")
const _hoisted_23 = /*#__PURE__*/_createVNode("span", null, "发送报告", -1)
const _hoisted_24 = /*#__PURE__*/_createTextVNode("取消")
const _hoisted_25 = { class: "Dialog" }
const _hoisted_26 = /*#__PURE__*/_createTextVNode("全部清空")
const _hoisted_27 = /*#__PURE__*/_createTextVNode("生成报告")
const _hoisted_28 = { align: "center" }
const _hoisted_29 = /*#__PURE__*/_createVNode("div", { class: "spacName" }, [
  /*#__PURE__*/_createVNode("img", {
    class: "banner",
    src: _imports_1,
    alt: ""
  })
], -1)
const _hoisted_30 = { class: "mainContent" }
const _hoisted_31 = { class: "spacName" }
const _hoisted_32 = { class: "gameTable" }
const _hoisted_33 = {
  rowspan: 3,
  class: "gameIcon"
}
const _hoisted_34 = {
  colspan: 3,
  class: "game_name"
}
const _hoisted_35 = /*#__PURE__*/_createTextVNode(" 测试版本: ")
const _hoisted_36 = /*#__PURE__*/_createTextVNode(" 测试时间: ")
const _hoisted_37 = /*#__PURE__*/_createVNode("td", null, [
  /*#__PURE__*/_createTextVNode(" 测试服: "),
  /*#__PURE__*/_createVNode("span", null, "1服")
], -1)
const _hoisted_38 = /*#__PURE__*/_createTextVNode(" 风险等级: ")
const _hoisted_39 = /*#__PURE__*/_createVNode("td", null, [
  /*#__PURE__*/_createTextVNode(" 测试类型: "),
  /*#__PURE__*/_createVNode("span", null, "TOP机型性能测试")
], -1)
const _hoisted_40 = /*#__PURE__*/_createTextVNode(" 测试平台: ")
const _hoisted_41 = { class: "corePerformance" }
const _hoisted_42 = /*#__PURE__*/_createVNode("h5", { class: "module-title" }, [
  /*#__PURE__*/_createVNode("span", { class: "title-prefix" }, "▍"),
  /*#__PURE__*/_createVNode("span", null, "一、测试概要")
], -1)
const _hoisted_43 = {
  class: "core-module",
  style: {"padding-bottom":"60px"}
}
const _hoisted_44 = { class: "test_Summary_box" }
const _hoisted_45 = { style: {"padding-top":"10px","font-size":"13px","font-style":"italic"} }
const _hoisted_46 = /*#__PURE__*/_createVNode("div", null, [
  /*#__PURE__*/_createVNode("h5", { class: "module-title" }, [
    /*#__PURE__*/_createVNode("span", { class: "title-prefix" }, "▍"),
    /*#__PURE__*/_createVNode("span", null, "二、版本通过率趋势图")
  ]),
  /*#__PURE__*/_createVNode("div", {
    class: "core-module",
    style: {"padding-top":"40px","padding-bottom":"40px"}
  }, [
    /*#__PURE__*/_createVNode("div", {
      id: "myChart",
      style: {"width":"100%","height":"450px"}
    })
  ])
], -1)
const _hoisted_47 = /*#__PURE__*/_createVNode("h5", { class: "module-title" }, [
  /*#__PURE__*/_createVNode("span", { class: "title-prefix" }, "▍"),
  /*#__PURE__*/_createVNode("span", null, "三、 问题机型列表")
], -1)
const _hoisted_48 = { class: "core-module" }
const _hoisted_49 = {
  class: "tableTitle",
  style: {"table-layout":"fixed","border-collapse":"collapse"}
}
const _hoisted_50 = {
  class: "table_head",
  style: {"background":"rgb(91, 155, 213)","height":"50px"}
}
const _hoisted_51 = { rowspan: "1" }
const _hoisted_52 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_53 = {
  key: 0,
  style: {"color":"rgb(91, 155, 213)"}
}
const _hoisted_54 = /*#__PURE__*/_createVNode("div", { style: {"margin-bottom":"40px"} }, [
  /*#__PURE__*/_createTextVNode(" 其他机型性能数据详见 "),
  /*#__PURE__*/_createVNode("a", { href: "/" }, "GameRobot")
], -1)
const _hoisted_55 = /*#__PURE__*/_createVNode("div", { class: "footer" }, [
  /*#__PURE__*/_createVNode("img", {
    src: _imports_2,
    alt: ""
  })
], -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_el_option = _resolveComponent("el-option")
  const _component_el_select = _resolveComponent("el-select")
  const _component_el_form_item = _resolveComponent("el-form-item")
  const _component_el_tooltip = _resolveComponent("el-tooltip")
  const _component_el_button = _resolveComponent("el-button")
  const _component_el_popconfirm = _resolveComponent("el-popconfirm")
  const _component_el_input = _resolveComponent("el-input")
  const _component_el_form = _resolveComponent("el-form")
  const _component_el_dialog = _resolveComponent("el-dialog")
  const _component_el_table_column = _resolveComponent("el-table-column")
  const _component_el_table = _resolveComponent("el-table")
  const _component_el_pagination = _resolveComponent("el-pagination")
  const _component_el_main = _resolveComponent("el-main")
  const _component_el_container = _resolveComponent("el-container")
  const _directive_loading = _resolveDirective("loading")

  return (_openBlock(), _createBlock(_component_el_container, null, {
    default: _withId(() => [
      _createVNode(_component_el_container, null, {
        default: _withId(() => [
          _createVNode(_component_el_main, { style: {"display":"flex"} }, {
            default: _withId(() => [
              _createVNode("div", _hoisted_1, [
                _createVNode("div", _hoisted_2, [
                  _createVNode("div", _hoisted_3, [
                    _createVNode(_component_el_form, {
                      inline: true,
                      size: "mini",
                      class: "spacForm queryReport"
                    }, {
                      default: _withId(() => [
                        _createVNode(_component_el_form_item, { label: "报告名称" }, {
                          default: _withId(() => [
                            _createVNode(_component_el_select, {
                              modelValue: _ctx.report_id,
                              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.report_id = $event)),
                              placeholder: "请选择",
                              onChange: _ctx.report_change
                            }, {
                              default: _withId(() => [
                                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.report_list, (item) => {
                                  return (_openBlock(), _createBlock(_component_el_option, {
                                    key: item.id,
                                    label: 
                        item.report_name +
                        '-[' +
                        item.create_date.replace('T', ' ') +
                        ']'
                      ,
                                    value: item.id
                                  }, null, 8, ["label", "value"]))
                                }), 128))
                              ]),
                              _: 1
                            }, 8, ["modelValue", "onChange"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_form_item, null, {
                          default: _withId(() => [
                            _createVNode(_component_el_popconfirm, {
                              onConfirm: _cache[2] || (_cache[2] = ($event: any) => (_ctx.handleDelete())),
                              title: "确认删除该报告？",
                              placement: "top"
                            }, {
                              reference: _withId(() => [
                                _createVNode(_component_el_button, {
                                  size: "mini",
                                  type: "info",
                                  disabled: _ctx.get_is_super
                                }, {
                                  default: _withId(() => [
                                    _createVNode(_component_el_tooltip, {
                                      effect: "dark",
                                      content: "暂无管理员权限",
                                      placement: "top",
                                      disabled: !_ctx.get_is_super
                                    }, {
                                      default: _withId(() => [
                                        _hoisted_4
                                      ]),
                                      _: 1
                                    }, 8, ["disabled"])
                                  ]),
                                  _: 1
                                }, 8, ["disabled"])
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_button, {
                              class: "editBtn",
                              size: "mini",
                              onClick: _ctx.handleEdit
                            }, {
                              default: _withId(() => [
                                _hoisted_5
                              ]),
                              _: 1
                            }, 8, ["onClick"]),
                            _createVNode(_component_el_dialog, {
                              modelValue: _ctx.dialogFormVisible1,
                              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.dialogFormVisible1 = $event))
                            }, {
                              footer: _withId(() => [
                                _createVNode("span", _hoisted_6, [
                                  _createVNode(_component_el_button, {
                                    onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.dialogFormVisible1 = false))
                                  }, {
                                    default: _withId(() => [
                                      _hoisted_7
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_el_button, {
                                    type: "primary",
                                    onClick: _ctx.dialogFormVisible2
                                  }, {
                                    default: _withId(() => [
                                      _hoisted_8
                                    ]),
                                    _: 1
                                  }, 8, ["onClick"])
                                ])
                              ]),
                              default: _withId(() => [
                                _withDirectives(_createVNode(_component_el_form, null, {
                                  default: _withId(() => [
                                    _createVNode(_component_el_form_item, {
                                      class: "reportName",
                                      label: "报告名称",
                                      "label-width": _ctx.formLabelWidth
                                    }, {
                                      default: _withId(() => [
                                        _createVNode(_component_el_input, {
                                          class: "report-input",
                                          modelValue: _ctx.reportForm.name,
                                          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.reportForm.name = $event)),
                                          autocomplete: "off",
                                          width: "500"
                                        }, null, 8, ["modelValue"])
                                      ]),
                                      _: 1
                                    }, 8, ["label-width"])
                                  ]),
                                  _: 1
                                }, 512), [
                                  [_vShow, _ctx.dialogFormVisible1]
                                ])
                              ]),
                              _: 1
                            }, 8, ["modelValue"]),
                            _createVNode(_component_el_button, {
                              type: "primary",
                              onClick: _ctx.sendOut,
                              class: "down_img"
                            }, {
                              default: _withId(() => [
                                _hoisted_9,
                                _hoisted_10
                              ]),
                              _: 1
                            }, 8, ["onClick"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode("div", null, [
                      _createVNode(_component_el_button, {
                        size: "mini",
                        type: "primary",
                        onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.dialogTableVisible = true)),
                        disabled: _ctx.get_is_super,
                        style: {"height":"28px"}
                      }, {
                        default: _withId(() => [
                          _createVNode(_component_el_tooltip, {
                            effect: "dark",
                            content: "暂无管理员权限",
                            placement: "top",
                            disabled: !_ctx.get_is_super
                          }, {
                            default: _withId(() => [
                              _hoisted_11
                            ]),
                            _: 1
                          }, 8, ["disabled"])
                        ]),
                        _: 1
                      }, 8, ["disabled"]),
                      _createVNode("div", _hoisted_12, [
                        _hoisted_13,
                        _createVNode(_component_el_button, {
                          size: "mini",
                          type: "primary",
                          onClick: _ctx.clear,
                          disabled: _ctx.get_is_super,
                          style: {"height":"28px","margin-left":"auto"}
                        }, {
                          default: _withId(() => [
                            _createVNode(_component_el_tooltip, {
                              effect: "dark",
                              content: "暂无管理员权限",
                              placement: "top",
                              disabled: !_ctx.get_is_super
                            }, {
                              default: _withId(() => [
                                _hoisted_14
                              ]),
                              _: 1
                            }, 8, ["disabled"])
                          ]),
                          _: 1
                        }, 8, ["onClick", "disabled"])
                      ])
                    ])
                  ]),
                  (_ctx.edit)
                    ? (_openBlock(), _createBlock("div", _hoisted_15, [
                        _createVNode(_component_el_form, {
                          "label-position": "left",
                          "label-width": "100px",
                          model: _ctx.formMail,
                          size: "mini"
                        }, {
                          default: _withId(() => [
                            _createVNode(_component_el_form_item, { label: "邮件标题" }, {
                              default: _withId(() => [
                                _createVNode(_component_el_input, {
                                  modelValue: _ctx.formMail.title,
                                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_ctx.formMail.title = $event))
                                }, null, 8, ["modelValue"])
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_form_item, { label: "邮件发件人" }, {
                              default: _withId(() => [
                                _createVNode(_component_el_tooltip, { placement: "bottom" }, {
                                  content: _withId(() => [
                                    _createTextVNode(" 指定的邮件发件人需要位于公司TOF发件人名单,否则无法发送邮件。默认邮件发件人" + _toDisplayString(_ctx.formMail.Sender), 1)
                                  ]),
                                  default: _withId(() => [
                                    _createVNode(_component_el_input, {
                                      modelValue: _ctx.formMail.Sender,
                                      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (_ctx.formMail.Sender = $event))
                                    }, null, 8, ["modelValue"])
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_form_item, { label: "邮件收件人" }, {
                              default: _withId(() => [
                                _createVNode(_component_el_tooltip, { placement: "bottom" }, {
                                  content: _withId(() => [
                                    _hoisted_16,
                                    _hoisted_17,
                                    _hoisted_18,
                                    _hoisted_19,
                                    _hoisted_20,
                                    _hoisted_21,
                                    _hoisted_22
                                  ]),
                                  default: _withId(() => [
                                    _createVNode(_component_el_input, {
                                      modelValue: _ctx.formMail.addressee,
                                      "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (_ctx.formMail.addressee = $event))
                                    }, null, 8, ["modelValue"])
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_form_item, { label: "邮件抄送人" }, {
                              default: _withId(() => [
                                _createVNode(_component_el_input, {
                                  modelValue: _ctx.formMail.CC_List,
                                  "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => (_ctx.formMail.CC_List = $event))
                                }, null, 8, ["modelValue"])
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_popconfirm, {
                              title: "确认发送报告吗？",
                              onConfirm: _cache[11] || (_cache[11] = ($event: any) => (_ctx.save_report(false))),
                              placement: "top"
                            }, {
                              reference: _withId(() => [
                                _createVNode(_component_el_button, {
                                  type: "primary",
                                  disabled: _ctx.get_is_super,
                                  size: "mini"
                                }, {
                                  default: _withId(() => [
                                    _createVNode(_component_el_tooltip, {
                                      effect: "dark",
                                      content: "暂无管理员权限",
                                      placement: "top",
                                      disabled: !_ctx.get_is_super
                                    }, {
                                      default: _withId(() => [
                                        _hoisted_23
                                      ]),
                                      _: 1
                                    }, 8, ["disabled"])
                                  ]),
                                  _: 1
                                }, 8, ["disabled"])
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_button, {
                              size: "mini",
                              type: "info",
                              onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.edit = false))
                            }, {
                              default: _withId(() => [
                                _hoisted_24
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }, 8, ["model"])
                      ]))
                    : _createCommentVNode("", true),
                  _createVNode("div", _hoisted_25, [
                    _createVNode(_component_el_dialog, {
                      width: "70%",
                      class: "customWidth",
                      modelValue: _ctx.dialogTableVisible,
                      "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => (_ctx.dialogTableVisible = $event))
                    }, {
                      default: _withId(() => [
                        _createVNode(_component_el_form, {
                          inline: true,
                          size: "mini"
                        }, {
                          default: _withId(() => [
                            _createVNode(_component_el_form_item, { label: "选择项目" }, {
                              default: _withId(() => [
                                _createVNode(_component_el_select, {
                                  modelValue: _ctx.project_search,
                                  "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => (_ctx.project_search = $event)),
                                  placeholder: "请选择项目",
                                  onChange: _cache[14] || (_cache[14] = ($event: any) => (_ctx.change_name_search1('project')))
                                }, {
                                  default: _withId(() => [
                                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.projectList, (item) => {
                                      return (_openBlock(), _createBlock(_component_el_option, {
                                        key: item.id,
                                        label: item.project_name,
                                        value: item.id
                                      }, null, 8, ["label", "value"]))
                                    }), 128))
                                  ]),
                                  _: 1
                                }, 8, ["modelValue"])
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_form_item, { label: "测试人员" }, {
                              default: _withId(() => [
                                _createVNode(_component_el_select, {
                                  modelValue: _ctx.testName_search,
                                  "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => (_ctx.testName_search = $event)),
                                  placeholder: "请选择测试人员",
                                  onChange: _cache[16] || (_cache[16] = ($event: any) => (_ctx.change_name_search1('userName')))
                                }, {
                                  default: _withId(() => [
                                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.testNameList, (item) => {
                                      return (_openBlock(), _createBlock(_component_el_option, {
                                        key: item.username,
                                        label: item.username,
                                        value: item.username
                                      }, null, 8, ["label", "value"]))
                                    }), 128))
                                  ]),
                                  _: 1
                                }, 8, ["modelValue"])
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_form_item, { label: "选择日期" }, {
                              default: _withId(() => [
                                _createVNode(_component_el_select, {
                                  modelValue: _ctx.date_search,
                                  "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => (_ctx.date_search = $event)),
                                  placeholder: "请选择日期",
                                  multiple: "",
                                  onChange: _cache[18] || (_cache[18] = ($event: any) => (_ctx.change_name_search1('dateTime')))
                                }, {
                                  default: _withId(() => [
                                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.dateList, (item) => {
                                      return (_openBlock(), _createBlock(_component_el_option, {
                                        key: item,
                                        label: item,
                                        value: item
                                      }, null, 8, ["label", "value"]))
                                    }), 128))
                                  ]),
                                  _: 1
                                }, 8, ["modelValue"])
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_form_item, null, {
                              default: _withId(() => [
                                _createVNode(_component_el_button, {
                                  type: "primary",
                                  onClick: _ctx.clearAll
                                }, {
                                  default: _withId(() => [
                                    _hoisted_26
                                  ]),
                                  _: 1
                                }, 8, ["onClick"])
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_form_item, null, {
                              default: _withId(() => [
                                _createVNode(_component_el_button, {
                                  type: "primary",
                                  onClick: _ctx.generateReportbtn
                                }, {
                                  default: _withId(() => [
                                    _hoisted_27
                                  ]),
                                  _: 1
                                }, 8, ["onClick"])
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        _withDirectives(_createVNode(_component_el_table, {
                          ref: "tb",
                          data: 
                    _ctx.top_report_table.slice(
                      (_ctx.currentPage - 1) * _ctx.pageSize,
                      _ctx.currentPage * _ctx.pageSize
                    )
                  ,
                          size: "mini",
                          "header-cell-class-name": "tabelHeader",
                          class: "tabelStyle",
                          "row-key": _ctx.getRowKeys,
                          onSelectionChange: _ctx.handleSelect
                        }, {
                          default: _withId(() => [
                            _createVNode(_component_el_table_column, {
                              type: "selection",
                              "reserve-selection": true
                            }),
                            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.columns, (item) => {
                              return (_openBlock(), _createBlock(_component_el_table_column, {
                                key: item.prop,
                                label: item.label,
                                prop: item.prop,
                                align: "left",
                                fixed: item.fixed,
                                width: item.width,
                                "show-overflow-tooltip": true
                              }, null, 8, ["label", "prop", "fixed", "width"]))
                            }), 128))
                          ]),
                          _: 1
                        }, 8, ["data", "row-key", "onSelectionChange"]), [
                          [_directive_loading, _ctx.loading]
                        ]),
                        _createVNode("div", _hoisted_28, [
                          _createVNode(_component_el_pagination, {
                            background: "",
                            layout: "prev, pager, next",
                            onCurrentChange: _ctx.handleCurrentChange,
                            "current-page": _ctx.currentPage,
                            "page-size": _ctx.pageSize,
                            total: _ctx.top_report_table.length
                          }, null, 8, ["onCurrentChange", "current-page", "page-size", "total"])
                        ])
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _hoisted_29,
                  _createVNode("div", _hoisted_30, [
                    _createVNode("div", _hoisted_31, [
                      _withDirectives(_createVNode("table", _hoisted_32, [
                        _createVNode("tr", null, [
                          _createVNode("td", _hoisted_33, [
                            _createVNode("img", {
                              src: _ctx.top_report.project_icon
                            }, null, 8, ["src"])
                          ]),
                          _createVNode("td", _hoisted_34, _toDisplayString(_ctx.top_report.project_name), 1)
                        ]),
                        _createVNode("tr", null, [
                          _createVNode("td", null, [
                            _hoisted_35,
                            _createVNode("span", null, _toDisplayString(_ctx.top_report.version), 1)
                          ]),
                          _createVNode("td", null, [
                            _hoisted_36,
                            _createVNode("span", null, _toDisplayString(_ctx.top_report_info.create_date), 1)
                          ]),
                          _hoisted_37
                        ]),
                        _createVNode("tr", null, [
                          _createVNode("td", null, [
                            _hoisted_38,
                            _createVNode("span", {
                              class: 
                          _ctx.top_report.risk === '高风险'
                            ? 'com_risk_red'
                            : 'com_risk_green'
                        
                            }, _toDisplayString(_ctx.top_report.risk), 3)
                          ]),
                          _hoisted_39,
                          _createVNode("td", null, [
                            _hoisted_40,
                            _createVNode("span", null, _toDisplayString(_ctx.top_report.base_info.platform), 1)
                          ])
                        ])
                      ], 512), [
                        [_directive_loading, _ctx.loading]
                      ])
                    ]),
                    _createVNode("div", _hoisted_41, [
                      _createVNode("div", null, [
                        _hoisted_42,
                        _createVNode("div", _hoisted_43, [
                          _createVNode("div", _hoisted_44, [
                            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.testSummary, (item) => {
                              return (_openBlock(), _createBlock("div", {
                                class: "test_Summary",
                                key: item,
                                id: item.value
                              }, [
                                _createVNode("div", null, _toDisplayString(item.label), 1),
                                _createVNode("div", null, _toDisplayString(item.value), 1)
                              ], 8, ["id"]))
                            }), 128))
                          ]),
                          _createVNode("div", _hoisted_45, [
                            _createTextVNode(" 本次共测试" + _toDisplayString(_ctx.top_report.base_info.test_model_num) + "台机器，覆盖用户占比" + _toDisplayString(_ctx.top_report.base_info.user_percent) + "%，机型与用户占比数据来源", 1),
                            _createVNode("a", {
                              href: _ctx.top_report.base_info.benchmark,
                              target: "_blank"
                            }, "benchmark", 8, ["href"])
                          ])
                        ])
                      ]),
                      _hoisted_46,
                      _createVNode("div", null, [
                        _hoisted_47,
                        _createVNode("div", _hoisted_48, [
                          _createVNode("table", _hoisted_49, [
                            _createVNode("tr", _hoisted_50, [
                              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.tableHead, (item) => {
                                return (_openBlock(), _createBlock("td", {
                                  key: item,
                                  style: {"text-align":"center","border":"1px solid #e2e7eb","color":"#fff","font-size":"13px"}
                                }, _toDisplayString(item), 1))
                              }), 128))
                            ]),
                            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.top_report.problem_model_list, (device, index) => {
                              return (_openBlock(), _createBlock("tbody", {
                                key: index,
                                style: {"font-size":"13px"}
                              }, [
                                (_openBlock(true), _createBlock(_Fragment, null, _renderList(device.rows, (row, i) => {
                                  return (_openBlock(), _createBlock("tr", { key: i }, [
                                    (i === 0)
                                      ? (_openBlock(), _createBlock("td", {
                                          key: 0,
                                          rowspan: device.rows.length
                                        }, _toDisplayString(index + 1), 9, ["rowspan"]))
                                      : _createCommentVNode("", true),
                                    (i === 0)
                                      ? (_openBlock(), _createBlock("td", {
                                          key: 1,
                                          rowspan: device.rows.length
                                        }, _toDisplayString(device.model), 9, ["rowspan"]))
                                      : _createCommentVNode("", true),
                                    (i === 0)
                                      ? (_openBlock(), _createBlock("td", {
                                          key: 2,
                                          rowspan: device.rows.length
                                        }, _toDisplayString(device.level_chinese), 9, ["rowspan"]))
                                      : _createCommentVNode("", true),
                                    (i === 0)
                                      ? (_openBlock(), _createBlock("td", {
                                          key: 3,
                                          rowspan: device.rows.length
                                        }, _toDisplayString(device.score), 9, ["rowspan"]))
                                      : _createCommentVNode("", true),
                                    (i === 0)
                                      ? (_openBlock(), _createBlock("td", {
                                          key: 4,
                                          rowspan: device.rows.length
                                        }, _toDisplayString(device.user_percentage), 9, ["rowspan"]))
                                      : _createCommentVNode("", true),
                                    _createVNode("td", _hoisted_51, [
                                      _createTextVNode(_toDisplayString(row.type === "url" ? "链接" : row.type), 1),
                                      _hoisted_52,
                                      (row.type != 'url')
                                        ? (_openBlock(), _createBlock("span", _hoisted_53, _toDisplayString(row.base), 1))
                                        : _createCommentVNode("", true)
                                    ]),
                                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(row.values, (value) => {
                                      return (_openBlock(), _createBlock("td", {
                                        key: value,
                                        rowspan: "1"
                                      }, [
                                        (row.type === 'url')
                                          ? (_openBlock(), _createBlock("a", {
                                              key: 0,
                                              href: value.value,
                                              target: "_blank"
                                            }, "链接", 8, ["href"]))
                                          : (_openBlock(), _createBlock("p", {
                                              key: 1,
                                              style: 'color: ' + value.color
                                            }, _toDisplayString(value.value), 5))
                                      ]))
                                    }), 128)),
                                    (i === 0)
                                      ? (_openBlock(), _createBlock("td", {
                                          key: 5,
                                          rowspan: device.rows.length,
                                          class: 
                              device.risk === '高风险'
                                ? 'high_color'
                                : 'mid_color'
                            
                                        }, [
                                          _createVNode("b", null, _toDisplayString(device.risk), 1)
                                        ], 10, ["rowspan"]))
                                      : _createCommentVNode("", true)
                                  ]))
                                }), 128))
                              ]))
                            }), 128))
                          ])
                        ]),
                        _hoisted_54
                      ])
                    ])
                  ])
                ]),
                _hoisted_55
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
})